import { memo, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Colors } from "../../utils/colors";
import { AccountData, NotificationType } from "@markit/common.types";
import { isDesktop as isDesktopDevice } from "react-device-detect";
import CustomTextField from "../CustomTextField";
import { showNotificationBanner } from "../../utils/notificationUtils";

type ProfilePageHideProfileModalProps = {
  userData: AccountData;
  profilePassword: string;
  setProfilePassword: (profilePassword: string) => void;
  forceMobile?: boolean;
};

const ProfilePageHideProfileModal = memo(function ProfilePageHideProfileModalFn(
  props: ProfilePageHideProfileModalProps
) {
  const { userData, profilePassword, setProfilePassword, forceMobile } = props;
  const dispatch = useDispatch();

  const isDesktop = useMemo(
    () => isDesktopDevice && !forceMobile,
    [forceMobile]
  );

  const styles = {
    floatingPasswordInput: {
      top: 40,
      right: 0,
      bottom: 0,
      left: 0,
      gap: 7,
      justifyContent: "center",
      backgroundColor: Colors.WHITE,
      padding: 14,
      borderRadius: 20,
      zIndex: 1,
      boxShadow: "0px 0.5px 1px 0px #b9b9b9",
      width: isDesktop ? "20vw" : 260,
      minWidth: isDesktop ? 240 : 260,
      height: "fit-content",
      marginInline: "auto",
    },
  };

  return (
    <div
      className="ColumnNormal"
      style={{ position: "absolute", ...styles.floatingPasswordInput }}
    >
      <span className="bodyMedium">Enter password to view content</span>
      <CustomTextField
        value={profilePassword}
        placeholder="Password"
        inputMode="text"
        borderRadius={12}
        noAutocomplete
        backgroundColor={Colors.WHITE}
        onChange={(change: any) => {
          const password = change.target.value;
          if (userData && password === userData.profilePasswordProtect) {
            showNotificationBanner(
              dispatch,
              "Profile Unlocked!",
              NotificationType.AFFIRMATIVE
            );
          }
          setProfilePassword(password);
        }}
        altMarginBottom={0}
        altPadding="14px 14px"
      />
    </div>
  );
});

export default ProfilePageHideProfileModal;
